import React, {Component} from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';

import {
    Nav, NavItem, NavLink,
    TabContent, TabPane,
} from 'reactstrap';

import PolyUtil from '../../../util/PolyUtil';
import {fetchPropertyRoommateGroups} from "../actions/owner";
import OwnerApplicationGroupRow from './OwnerApplicationGroupRow';
import Loader from "../../../components/display/Loader";

class OwnerListingRow extends Component {
    state = {
        activeTab: '1',
    };

    getUnacceptedGroups = (groups) => {
        if (!groups) return [];

        return groups.filter(function (group) {
            return group.accepted === false;
        });
    };

    getAcceptedGroups = (groups) => {
        if (!groups) return [];

        return groups.filter(function (group) {
            return group.accepted === true;
        });
    };

    componentWillMount() {
        const prop_id = this.props.property.id;
        const listing_id = this.props.property.active_listing.id;

        this.props._fetchPropertyRoommateGroups(prop_id, listing_id);
    }

    toggle = (tab) => {
        this.state.activeTab !== tab && this.setState({activeTab: tab});
    };

    render() {
        const {property, roommate_groups} = this.props;

        const hasGroupCounts = property.active_listing.applied_roommate_group_counts;
        const triageGroupsCount = hasGroupCounts ? (property.active_listing.applied_roommate_group_counts.pending) : 0;
        const qualifiedGroupsCount = hasGroupCounts ? (property.active_listing.applied_roommate_group_counts.accepted) : 0;

        return (
            <div style={{marginTop: '2em'}}>
                <h3>
                    <strong><a href={"/listings/" + property.active_listing.apply_key + "/"}
                               target="_blank">{PolyUtil.getPropertyStreetAddress(property)}{property.identifier && " (" + property.identifier + ")"}</a></strong>
                </h3>
                <h5 style={{marginTop: "-0.5rem"}}>
                    <small><strong>{PolyUtil.getPropertyCity(property) + ", " + PolyUtil.getPropertyState(property)}</strong></small>
                </h5>
                <Nav>
                    <NavItem>
                        <NavLink className={classnames({'nav-tab-active': this.state.activeTab === '1'})}
                                 onClick={() => this.toggle('1')}>
                            Triage ({triageGroupsCount})
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({'nav-tab-active': this.state.activeTab === '2'})}
                                 onClick={() => this.toggle('2')}>
                            Qualified ({qualifiedGroupsCount})
                        </NavLink>
                    </NavItem>
                </Nav>
                <Loader spin isLoading={!roommate_groups}>
                    <TabContent activeTab={this.state.activeTab}>
                        <TabPane tabId="1">
                            <div className="owner-property-applications-container">
                                {
                                    PolyUtil.validArr(this.getUnacceptedGroups(roommate_groups)) ? this.getUnacceptedGroups(roommate_groups).map(function (group, i) {
                                            return (
                                                <OwnerApplicationGroupRow key={i} roommateGroup={group} ids={{prop_id: property.id, listing_id: property.active_listing.id}}/>
                                            );
                                        }
                                    ) : (
                                        <div className="center" style={{margin: '2em 0 2em 0'}}>
                                            <h4>No new applications (yet!)</h4>
                                        </div>
                                    )
                                }
                            </div>
                        </TabPane>
                        <TabPane tabId="2">
                            <div className="owner-property-applications-container">
                                {
                                    PolyUtil.validArr(this.getAcceptedGroups(roommate_groups)) ? this.getAcceptedGroups(roommate_groups).map(function (group, i) {
                                            return (
                                                <OwnerApplicationGroupRow key={i} roommateGroup={group} ids={{prop_id: property.id, listing_id: property.active_listing.id}}/>
                                            );
                                        }
                                    ) : (
                                        <div className="center" style={{margin: '2em 0 2em 0'}}>
                                            <h4>No qualified groups (yet!)</h4>
                                        </div>
                                    )
                                }
                            </div>
                        </TabPane>
                    </TabContent>
                </Loader>
                <hr/>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    const application = state.owner.applications.find((app) => {
        return app.prop_id === props.property.id && app.listing_id === props.property.active_listing.id;
    });

    return {
        roommate_groups: application && application.roommate_groups
    };
};

const mapDispatchToProps = (dispatch) => ({
    _fetchPropertyRoommateGroups(prop_id, listing_id) {
        return dispatch(fetchPropertyRoommateGroups(prop_id, listing_id));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(OwnerListingRow);



// WEBPACK FOOTER //
// ./src/containers/owner/applications/OwnerListingRow.js